import airbridge from 'airbridge-web-sdk-loader';
import {EventOption} from 'airbridge-web-sdk-loader/build/airbridge_api';
import {UserProfile} from '@/interface';
import {HOSTNAME} from '@/router';

export const setGtagUserInfomation = (user: {user_id?: string}) => {
  const {gtag} = window;

  if (user.user_id) {
    user.user_id = btoa(user.user_id);
  }

  if (window.location.host === HOSTNAME) {
    gtag('set', user);
  } else {
    console.log('Set gtag user info(develop)', user);
  }
};

export const trackingGA = (name: string, parameters?: Gtag.CustomParams) => {
  const {gtag} = window;

  if (window.location.host === HOSTNAME) {
    gtag('event', name, parameters);
  } else {
    console.log('Track Event(develop)', name, parameters);
    parameters?.event_callback?.();
  }
};

export const setAirbridgeOnboardingProfile = (profile?: UserProfile) => {
  airbridge.setUserAttribute('ageGroup', profile?.ageGroup);
  airbridge.setUserAttribute('category', profile?.category);
  airbridge.setUserAttribute('categoryOther', profile?.otherCategory);
  airbridge.setUserAttribute('gender', profile?.gender);
  airbridge.setUserAttribute('purpose', profile?.purpose);
  airbridge.setUserAttribute('purposeOther', profile?.other);
};

export const trackAirbridge = (
  category: string,
  eventAttribute?: EventOption
) => {
  try {
    airbridge.events.send(category, eventAttribute);
  } catch (e) {
    console.error(e);
  }
};
